import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { IconBundleBlueprint } from '@backstage/plugin-app-react';

import MuiApartmentIcon from '@material-ui/icons/Apartment';
import MuiBrokenImageIcon from '@material-ui/icons/BrokenImage';
import MuiCategoryIcon from '@material-ui/icons/Category';
import MuiCreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import MuiSubjectIcon from '@material-ui/icons/Subject';
import MuiSearchIcon from '@material-ui/icons/Search';
import MuiChatIcon from '@material-ui/icons/Chat';
import MuiDashboardIcon from '@material-ui/icons/Dashboard';
import MuiDocsIcon from '@material-ui/icons/Description';
import MuiEmailIcon from '@material-ui/icons/Email';
import MuiExtensionIcon from '@material-ui/icons/Extension';
import MuiGitHubIcon from '@material-ui/icons/GitHub';
import MuiHelpIcon from '@material-ui/icons/Help';
import MuiLocationOnIcon from '@material-ui/icons/LocationOn';
import MuiMemoryIcon from '@material-ui/icons/Memory';
import MuiMenuBookIcon from '@material-ui/icons/MenuBook';
import MuiPeopleIcon from '@material-ui/icons/People';
import MuiPersonIcon from '@material-ui/icons/Person';
import MuiWarningIcon from '@material-ui/icons/Warning';
import MuiStorageIcon from '@material-ui/icons/Storage';
import MuiFeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import OpenInNew from '@material-ui/icons/OpenInNew';

// Backstage's @backstage/plugin-app/app-defaults registers the standard icon
// set as IconComponent (the deprecated form), which makes DefaultIconsApi log
// a warning on every page load. Re-register the same icons as IconElement
// (JSX) so the merge in DefaultIconsApi takes the IconElement path and the
// warning goes away. Until app-defaults upstream switches to elements, this
// override is the cleanest way to silence the warning without forking.
const iconsBundle = IconBundleBlueprint.make({
  params: {
    icons: {
      brokenImage: <MuiBrokenImageIcon />,
      catalog: <MuiMenuBookIcon />,
      scaffolder: <MuiCreateNewFolderIcon />,
      techdocs: <MuiSubjectIcon />,
      search: <MuiSearchIcon />,
      chat: <MuiChatIcon />,
      dashboard: <MuiDashboardIcon />,
      docs: <MuiDocsIcon />,
      email: <MuiEmailIcon />,
      github: <MuiGitHubIcon />,
      group: <MuiPeopleIcon />,
      help: <MuiHelpIcon />,
      'kind:api': <MuiExtensionIcon />,
      'kind:component': <MuiMemoryIcon />,
      'kind:domain': <MuiApartmentIcon />,
      'kind:group': <MuiPeopleIcon />,
      'kind:location': <MuiLocationOnIcon />,
      'kind:system': <MuiCategoryIcon />,
      'kind:user': <MuiPersonIcon />,
      'kind:resource': <MuiStorageIcon />,
      'kind:template': <MuiFeaturedPlayListIcon />,
      user: <MuiPersonIcon />,
      warning: <MuiWarningIcon />,
      star: <Star />,
      unstarred: <StarBorder />,
      externalLink: <OpenInNew />,
    },
  },
});

export const iconsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [iconsBundle],
});
